import styled from 'styled-components';

const MainNavStyled = styled.nav`
  max-width: 710px;
  width: 100%;
  height: 90px;
  display: flex;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
  z-index: 97;
  padding: 0 15px;
  @media (min-width: 769px) {
    padding: 0;
  }
`;

const LogoContainerStyled = styled.div`
  padding-right: 20px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    transition: transform 0.3s;
    cursor: pointer;
    &:hover {
      transform: rotate(180deg);
    }
  }
`;

export { MainNavStyled, LogoContainerStyled };
